import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AppShell from './components/Layout/AppShell';
import RouteScrollReset from './components/Layout/RouteScrollReset';
import Dashboard from './components/Dashboard/Dashboard';
import UserManagement from './components/Users/UserManagement';
import TransactionList from './components/Transactions/TransactionList';
import Settlements from './components/Settlements/Settlements';
import Reconciliation from './components/Reconciliation/Reconciliation';
import Settings from './components/Settings/Settings';
import EmbedTest from './components/Embed/EmbedTest';
import PublicPaymentPage from './components/Embed/PublicPaymentPage';
import IframePaymentPage from './components/Iframe/IframePaymentPage';
import { getCurrentUserRole } from './utils/auth';

const ProtectedLayout: React.FC = () => (
  <ProtectedRoute>
    <AppShell>
      <Outlet />
    </AppShell>
  </ProtectedRoute>
);

function App() {
  const userRole = getCurrentUserRole();

  return (
    <Router unstable_useTransitions={false}>
      <RouteScrollReset />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/users"
            element={userRole === 'Agent' ? <Navigate to="/dashboard" replace /> : <UserManagement />}
          />
          <Route path="/transactions" element={<TransactionList />} />
          <Route path="/settlements" element={<Settlements />} />
          <Route path="/reconciliation" element={<Reconciliation />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/embed-test" element={<EmbedTest />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

        <Route path="/iframe/:embedToken" element={<IframePaymentPage />} />
        <Route path="/pay/:uniqueHash/swap" element={<PublicPaymentPage />} />
        <Route path="/pay/:uniqueHash" element={<PublicPaymentPage />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
